module.exports = __webpack_public_path__ + "static/media/infant.3902d9a4.jpg";